import { useEffect, useState } from 'react';
import "./AppointmentPage.css";


const PersonalInfo = ({ 
  handleChange, 
  selectValue, 
  additionalInfo,
  setAdditionalInfo }) => {

  console.log("selectValue", selectValue);

  const {
    firstName = "",
    lastName = "",
    email = "",
    phoneNumber = "",
    city = "",
    zipCode = "",
    street = "",
    addressNo = "",
    state = "",
    country = ""
  } = selectValue || {};


  const handleChangeAddInfo = (e) => {
    setAdditionalInfo(e.target.value);
  };

  return (
    <form className="rounded p-3 mt-5" style={{ background: "#f8f9fa" }}>
      <div className="row">
        <div className="col-md-6 col-sm-12">
          <div className="form-group card-label mb-3">
            <label>Imię</label>
            <input
              onChange={(e) => handleChange(e)}
              name="firstName"
              value={firstName ? firstName : ""}
              className="form-control"
              type="text"
            />
          </div>
        </div>

        <div className="col-md-6 col-sm-12">
          <div className="form-group card-label mb-3">
            <label>Nazwisko</label>
            <input
              onChange={(e) => handleChange(e)}
              name="lastName"
              value={lastName ? lastName : ""}
              className="form-control"
              type="text"
            />
          </div>
        </div>

        <div className="col-md-6 col-sm-12">
          <div className="form-group card-label mb-3">
            <label>Email</label>
            <input
              onChange={(e) => handleChange(e)}
              name="email"
              value={email ? email : ""}
              className="form-control"
              type="email"
            />
          </div>
        </div>

        <div className="col-md-6 col-sm-12" style={{paddingBottom:"2rem"}}>
          <div className="form-group card-label mb-3">
            <label>Numer Telefonu</label>
            <input
              onChange={(e) => handleChange(e)}
              name="phoneNumber"
              value={phoneNumber ? phoneNumber : ""}
              className="form-control"
              type="text"
            />
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="form-group card-label mb-3">
            <label>Miasto</label>
            <input
              onChange={(e) => handleChange(e)}
              name="city"
              value={city ? city : ""}
              className="form-control"
              type="text"
            />
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="form-group card-label mb-3">
            <label>Kod Pocztowy</label>
            <input
              onChange={(e) => handleChange(e)}
              name="zipCode"
              value={zipCode ? zipCode : ""}
              className="form-control"
              type="text"
            />
          </div>
        </div>

        <div className="col-md-6 col-sm-12">
          <div className="form-group card-label mb-3">
            <label>Ulica</label>
            <input
              onChange={(e) => handleChange(e)}
              name="street"
              value={street ? street : ""}
              className="form-control"
              type="text"
            />
          </div>
        </div>

        <div className="col-md-6 col-sm-12">
          <div className="form-group card-label mb-3">
            <label>Numer Domu/Lokalu</label>
            <input
              onChange={(e) => handleChange(e)}
              name="addressNo"
              value={addressNo ? addressNo : ""}
              className="form-control"
              type="text"
            />
          </div>
        </div>

        <div className="col-md-6 col-sm-12">
          <div className="form-group card-label mb-3">
            <label>Województwo</label>
            <input
              onChange={(e) => handleChange(e)}
              name="state"
              value={state ? state : ""}
              className="form-control"
              type="text"
            />
          </div>
        </div>

        <div className="col-md-6 col-sm-12" style={{paddingBottom:"2rem"}}>
          <div className="form-group card-label mb-3">
            <label>Państwo</label>
            <input
              onChange={(e) => handleChange(e)}
              name="country"
              value={country ? country : ""}
              className="form-control"
              type="text"
            />
          </div>
        </div>


        <div >
          <div className="form-group card-label mb-3">
            <label>Dodatkowe Informacje (opcjonalnie)</label>
            <textarea
              rows={3}
              onChange={(e) => handleChangeAddInfo(e)}
              name="additionalInfo"
              value={additionalInfo ? additionalInfo : ""}
              className="form-control"
              type="text"
            />
          </div>
        </div>
      </div>
    </form>
  );
};

export default PersonalInfo;
